module.exports = __webpack_public_path__ + "img/sign-51.30fb2b1b.jpg";